import React from "react";

const SuccessIcon = () => (
  <svg
    className="w-8 h-8"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  </svg>
);

const ErrorIcon = () => (
  <svg
    className="w-8 h-8"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
  </svg>
);

const NotificationDialog = ({ notificationMessage, isError }) => {
  const colors = isError
    ? "bg-red-100 text-red-600"
    : "bg-green-100 text-green-600";

  return (
    <div className="flex flex-col items-center text-center gap-4 py-2">
      <div
        className={`flex items-center justify-center w-14 h-14 rounded-full ${colors}`}
      >
        {isError ? <ErrorIcon /> : <SuccessIcon />}
      </div>
      <p className="text-sm text-gray-700 leading-relaxed max-w-sm">
        {notificationMessage}
      </p>
    </div>
  );
};

export default NotificationDialog;
